import { gql } from '@apollo/client';

/*
 ** ADD BROADCAST LIVE **
 */

export const ADD_BROADCAST_LIVE = gql`
  mutation AddBroadcastLive($input: AddBroadcastLiveInput!) {
    addBroadcastLive(input: $input) {
      broadcastLive {
        blId
      }
      message
    }
  }
`;

export type AddBroadcastLiveResult = {
  blId: string;
};

export type AddBroadcastLiveData = {
  addBroadcastLive: {
    broadcastLive: AddBroadcastLiveResult | null;
    message: string;
  } | null;
};

export type AddBroadcastLiveInput = {
  clusterRegion: string;
  thumbnailUrl: string;
  dvrWindow: number;
  endTime: string;
  ingestFormat: string;
  startTime: string;
  streamType: string;
  title: string;
  description?: string;
};

export type AddBroadcastLiveVariables = {
  input: AddBroadcastLiveInput;
};



export const EDIT_BROADCAST_LIVE = gql`
  mutation EditLiveStream($input: EditBroadcastLiveInput!) {
    editLiveStream(input: $input)
  }
`;

export type EditBroadcastLiveData = {
  editLiveStream: boolean;
};

export type EditBroadcastLiveInput = {
  blId: string;
  blTitle?: string;
  blDescription?: string;
  blThumbnailUrl?: string;
  blStartTime?: string;
  blEndTime?: string;
};

export type EditBroadcastLiveVariables = {
  input: EditBroadcastLiveInput;
};